<template>
   <div class="fliggy-select-file-btn" v-if="order.ota_info && !order.ota_info.ota_offline">
    <button  class="s-btn btn-blue is-plain btn-size-28" @click="onShowDialog">
      {{btnText || '从飞猪资料包选取'}}
    </button>
    <fliggy-select-file-dialog
      :visible.sync="showDialog"
      :applicant="applicant"
      :support-pdf="supportPdf"
      :material-name="materialName"
      :max-select-num="maxSelectNum"
      @confirm="$emit('confirm', $event)"
    ></fliggy-select-file-dialog>
  </div>
  
</template>

<script>
import FliggySelectFileDialog from './fliggy-select-file-dialog.vue';

export default {
  components: {
    FliggySelectFileDialog,
  },
  props: {
    order: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    applicant: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    materialName: String,
    supportPdf: Boolean,
    maxSelectNum: Number,
    btnText: String,
  },
  data() {
    return {
      showDialog: false,
    };
  },
  computed: {},
  created() {},
  methods: {
    onShowDialog() {
      this.showDialog = true;
    },
  },
};
</script>

<style lang="less" scoped>
.fliggy-select-file-btn{
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/upload/ota/fliggy-select-file-btn.vue